import template from './advertFeaturePage.html';
import controller from './advertFeaturePage.controller';
import './advertFeaturePage.scss';

let advertFeaturePageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default advertFeaturePageComponent;
